export const hasPermission = (userPermissions, permissionCode) => {
    if (!userPermissions || !Array.isArray(userPermissions)) {
        return false;
    }

    return userPermissions.some(permissionGroup =>
        permissionGroup.permission_list &&
        permissionGroup.permission_list.includes(permissionCode)
    );
};

export const hasModulePermission = (userPermissions, moduleCode) => {
    if (!userPermissions || !Array.isArray(userPermissions)) {
        return false;
    }

    return userPermissions.some(permissionGroup =>
        permissionGroup.is_module_level === true &&
        permissionGroup.permission_list &&
        permissionGroup.permission_list.includes(moduleCode)
    );
};